import React from "react";
import LuggageIcon from '@mui/icons-material/Luggage';


export default function EmptySavedPlaces(){
    return (
        <div style={{ textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", height: "90vh" }}>
            <div>
                <LuggageIcon sx={{width: 150, height: 150}}></LuggageIcon>
                <h2>Start Saving Places</h2>
                <p>Click on the bookmark icon of any place to make this part of your adventure wishlist!</p>
            </div>
        </div>
    )
}
